import { render } from "./permissionGrouping.vue?vue&type=template&id=3215a288"
import script from "./permissionGrouping.vue?vue&type=script&lang=js"
export * from "./permissionGrouping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__